import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vertical-1mpJB",
  "use": "vertical-1mpJB-usage",
  "viewBox": "0 0 4 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 18\" id=\"vertical-1mpJB\"><path fill-rule=\"evenodd\" d=\"M0 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol